export * from "api/authorization";
export * from "api/autocomplete";
export * from "api/emailScheduler";
export * from "api/templates";
export * from "api/creativeMappings";
export * from "api/creatives";
export * from "api/filters";
export * from "api/schemas";
export * from "api/api";

export interface Filter {
    type?: string;
    name: string;
    translation?: Readonly<string>;
    values: string[];
    value?: string;
    operator: string;
    logic?: string;
}
